import {eventBus} from '@/script/eventBus.mjs'
import metaBizNode from '../metaBizNode.mjs'

export default () => {
    const watchers = {
        load() {
            eventBus.publish('map_load', this)
        },

        meta_change(meta) {
            eventBus.publish('map_meta_change', meta)
        },

        model_change(changeSet) {
            for (const [node, changes] of changeSet.entries()) {
                if (changes.has('data')) {
                    const {bizNodeType} = node.data

                    if (
                        ! node.parent &&
                        metaBizNode[bizNodeType]?.classes.includes('design')
                    ) {
                        eventBus.publish('dp_change', node.data)
                    }
                }
            }
        },
    }

    return {watchers}
}
